import { Attachment } from "@features/comment"

export const fileToAttachment = (file: File): Promise<Attachment> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      resolve({ name: file.name, contentBytes: event.target?.result as string, contentType: file.type || "application/octet-stream" })
    }
    reader.onerror = (error) => {
      reject(error)
    }
    reader.readAsDataURL(file)
  })
}
